import { z } from 'zod';
import { chat } from './Chat';
import { EndpointContract } from '../../architecture/ControllerContract';

import { objectId } from '../../models/ObjectId';

const params = z
    .object({
        chatId: objectId
    })
    .strict();

export const getChatById = {
    verb: 'get',
    path: ':chatId',
    schema: {
        params,
        response: {
            200: chat,
            404: z.unknown()
        }
    }
} as const satisfies EndpointContract;
